var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38817 0H0V17L17 0H12.1198L3.49675 8.5191V3.84994L7.38817 0Z",
    fill: "url(#paint0_linear_345_60)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16475 13.4684L4.70195 17H17V4.5588L13.5372 8.02247V13.4684H8.16475Z",
    fill: "url(#paint1_linear_345_60)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_345_60",
    x1: 8.5,
    y1: 0,
    x2: 8.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_345_60",
    x1: 8.5,
    y1: 0,
    x2: 8.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.d39333c030d1867c9d7ba674ed9d700b.svg";
export { ForwardRef as ReactComponent };